import * as React from 'react'
import { FC } from 'react'
import Receipts from './recepts'

interface ReceptsConfigProps {
    config: string
}

const ReceptsConfig: FC<ReceptsConfigProps> = ({ config }) => {
    return config === 'Ожидаемые' ? (
        <Receipts
            receiptStatusFilters={['Создан', 'Прибыл', 'В приемке']}
            sort={['createdAt:asc']}
            actions
        />
    ) : (
        <Receipts receiptStatusFilters={['Завершен', 'Отменен']} />
    )
}

export default ReceptsConfig
